import './App.scss';
import { Navigate, Route, Routes } from "react-router-dom";
import { Welcome } from './components/Welcome/Welcome';
import { Login } from './components/Welcome/Login/Login';
import { Register } from './components/Register/Register';
import { Introduction } from './pages/Introduction/Introduction';
import { NotFound } from './pages/NotFound/NotFound';
import { Intro } from './pages/Flow/Intro/Intro';
import { PurposeIntroduction } from './pages/Flow/Purpose/Introduction';
import { PurposePassion } from "./pages/Flow/Purpose/PurposePassion";
import { Results } from './pages/Results/Results';
import { PurposePeople } from './pages/Flow/Purpose/PurposePeople';
import { PurposeImpact } from './pages/Flow/Purpose/PurposeImpact';
import { PurposeProduct } from './pages/Flow/Purpose/PurposeProduct';
import { PurposeStatement } from './pages/Flow/Purpose/PurposeStatement';
import { Vision } from './pages/Flow/Vision/Vision';
import { VisionStatement } from './pages/Flow/Vision/VisionStatement';
import { PersonalityIntroduction } from './pages/Flow/Personality/PersonalityIntroduction';
import { RelationshipsCompetition } from './pages/Flow/Relationships/RelationshipsCompetition';
import { PersonalityLook } from './pages/Flow/Personality/PersonalityLook';
import { PersonalityValues } from './pages/Flow/Personality/PersonalityValues';
import { PersonalityTone } from './pages/Flow/Personality/PersonalityTone';
import { PersonalityAttributes } from './pages/Flow/Personality/PersonalityAttributes';
import { RelationshipsTrends } from './pages/Flow/Relationships/RelationshipsTrends';
import { PositioningStatement } from './pages/Flow/Positioning/PositioningStatement';
import { Checkout } from './pages/Checkout/Checkout';
import { ProtectedRoute } from './components/Routes/ProtectedRoute';
import { NotPaid } from './pages/NotPaid/NotPaid';
import { ForgotPassword } from './pages/Password/ForgotPassword';
import { ResultsPurpose } from './pages/Results/ResultsPurpose';
import { ResultsVision } from './pages/Results/ResultsVision';
import { ResultsValues } from './pages/Results/ResultsValues';
import { ResultsPositioning } from './pages/Results/ResultsPositioning';
import { ResultsLook } from './pages/Results/ResultsLook';
import { ResultsTone } from './pages/Results/ResultsTone';
import { ResultsAttributes } from './pages/Results/ResultsAttributes';
import { ResultsCompetition } from './pages/Results/ResultsCompetition';
import { ResultsContent } from './pages/Results/ResultsContent';
import { ResultsTrends } from './pages/Results/ResultsTrends';
import Discount from './pages/Checkout/Discount';
import { Mobile } from './pages/NotFound/Mobile';
import { Dashboard } from './pages/Dashboard/Dashboard';
import { Users } from './components/Dashboard/Users';
import { User } from './components/Dashboard/User';
import { ResetPassword } from './pages/Password/ResetPassword';

function App() {
  return (
    <>
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/reset-password' element={<ResetPassword />} />
        <Route path='/register' element={<Register />} />
        <Route path='/mobile' element={<Mobile />} />
        <Route path='*' element={<NotFound />} />

        <Route path='/payment-failed' element={<NotPaid />} />

        <Route path="/"
          element={
            <ProtectedRoute shouldCheckCompleted shouldCheckPayment={false}>
              <Welcome />
            </ProtectedRoute>
          }
        />

        <Route path='/introduction'
          element={
            <ProtectedRoute shouldCheckCompleted shouldCheckPayment={false}>
              <Introduction />
            </ProtectedRoute>
          } />

        <Route path='/flow/intro'
          element={
            <ProtectedRoute shouldCheckCompleted>
              <Intro />
            </ProtectedRoute>
          } />

        <Route path='/flow/purpose'
          element={
            <ProtectedRoute shouldCheckCompleted>
              <PurposeIntroduction />
            </ProtectedRoute>
          } />

        <Route path='/flow/purpose/passion'
          element={
            <ProtectedRoute shouldCheckCompleted>
              <PurposePassion />
            </ProtectedRoute>
          } />

        <Route path='/flow/purpose/people'
          element={
            <ProtectedRoute shouldCheckCompleted>
              <PurposePeople />
            </ProtectedRoute>
          } />

        <Route path='/flow/purpose/impact'
          element={
            <ProtectedRoute shouldCheckCompleted>
              <PurposeImpact />
            </ProtectedRoute>
          } />

        <Route path='/flow/purpose/product'
          element={
            <ProtectedRoute shouldCheckCompleted>
              <PurposeProduct />
            </ProtectedRoute>
          } />

        <Route path='/flow/purpose/statement'
          element={
            <ProtectedRoute shouldCheckCompleted shouldCheckPayment={false}>
              <PurposeStatement />
            </ProtectedRoute>
          } />

        <Route path='/flow/vision'
          element={
            <ProtectedRoute shouldCheckPayment={false} shouldCheckCompleted>
              <Vision />
            </ProtectedRoute>
          } />
        <Route path='/flow/vision/statement'
          element={
            <ProtectedRoute shouldCheckPayment={false} shouldCheckCompleted>
              <VisionStatement />
            </ProtectedRoute>
          } />
          
        <Route path='/flow/personality/introduction'
          element={
            <ProtectedRoute shouldCheckPayment={false} shouldCheckCompleted>
              <PersonalityIntroduction />
            </ProtectedRoute>
          }
        />

        <Route path='/flow/personality/values'
          element={
            <ProtectedRoute shouldCheckPayment={false} shouldCheckCompleted>
              <PersonalityValues />
            </ProtectedRoute>
          }
        />

        <Route path='/flow/personality/look'
          element={
            <ProtectedRoute shouldCheckPayment={false} shouldCheckCompleted>
              <PersonalityLook />
            </ProtectedRoute>
          }
        />

        <Route path='/flow/personality/tone'
          element={
            <ProtectedRoute shouldCheckPayment={false} shouldCheckCompleted>
              <PersonalityTone />
            </ProtectedRoute>
          }
        />

        <Route path='/flow/personality/attributes'
          element={
            <ProtectedRoute shouldCheckPayment={false} shouldCheckCompleted>
              <PersonalityAttributes />
            </ProtectedRoute>
          }
        />

        <Route path='/flow/relationships/competition'
          element={
            <ProtectedRoute shouldCheckPayment={false} shouldCheckCompleted>
              <RelationshipsCompetition />
            </ProtectedRoute>} />

        <Route path='/flow/relationships/trends'
          element={
            <ProtectedRoute shouldCheckPayment={false} shouldCheckCompleted>
              <RelationshipsTrends />
            </ProtectedRoute>} />

        <Route path='/flow/positioning'
          element={
            <ProtectedRoute shouldCheckPayment={false} shouldCheckCompleted>
              <PositioningStatement />
            </ProtectedRoute>} />

        <Route path='/flow/checkout' element={<Discount />} />
        <Route path='/checkout' element={<Checkout />} />

        <Route path='/results' element={<Results />}>
          <Route index element={<Navigate to="purpose" />} />
          <Route path='purpose' element={<ResultsPurpose />} />
          <Route path='vision' element={<ResultsVision />} />
          <Route path='values' element={<ResultsValues />} />
          <Route path='positioning' element={<ResultsPositioning />} />
          <Route path='look' element={<ResultsLook />} />
          <Route path='tone' element={<ResultsTone />} />
          <Route path='attributes' element={<ResultsAttributes />} />
          <Route path='competition' element={<ResultsCompetition />} />
          <Route path='trends' element={<ResultsTrends />} />
          <Route path='content' element={<ResultsContent />} />
        </Route>

        <Route path='/dashboard' element={<Dashboard />}>
          <Route path='users' element={<Users />} />
          <Route path='users/:id' element={<User />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
